import React from "react"
import {SpeedInsights} from "@vercel/speed-insights/next"
import {Analytics} from "@vercel/analytics/next"
import {IS_PROD} from "@/constants";

const QualityTools = () => {
	if (!IS_PROD) return null
	return (
		<>
			<SpeedInsights sampleRate={0.05}/>
			<Analytics/>
		</>
	)
}

export default QualityTools
